import React, { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { CheckCircle, Envelope, ArrowRight } from "@phosphor-icons/react";
import Seo from "../components/Seo";

const Unsubscribed = () => {
  const [params] = useSearchParams();
  const [email, setEmail] = useState("");

  useEffect(() => {
    setEmail(params.get("email") || "");
  }, [params]);

  return (
    <div className="min-h-[60vh] flex items-center py-20" data-testid="page-unsubscribed">
      <Seo title="Unsubscribed" noindex />
      <div className="container-x max-w-xl mx-auto text-center">
        <span className="inline-flex items-center justify-center w-14 h-14 rounded-full bg-emerald-100 text-emerald-700 mx-auto">
          <CheckCircle size={28} weight="duotone" />
        </span>
        <h1 className="mt-6 font-heading text-3xl sm:text-4xl font-medium text-ink-900 leading-[1.15]">
          You&rsquo;ve been unsubscribed.
        </h1>
        <p className="mt-4 text-ink-700 leading-relaxed">
          {email ? (
            <>
              <span className="font-semibold text-ink-900">{email}</span> will
              no longer receive newsletter emails from Begin Again Living
              Ministries.
            </>
          ) : (
            <>
              Your email will no longer receive newsletter emails from Begin
              Again Living Ministries.
            </>
          )}
        </p>
        <p className="mt-3 text-ink-500 text-sm leading-relaxed">
          If this was a mistake, you can resubscribe any time from our{" "}
          <Link to="/" className="text-primary underline decoration-primary/30 hover:decoration-primary">
            homepage
          </Link>{" "}
          or by contacting us.
        </p>

        <div className="mt-10 flex flex-wrap justify-center gap-3">
          <Link
            to="/"
            data-testid="unsub-home-btn"
            className="inline-flex items-center gap-2 bg-primary text-white rounded-full px-6 py-3 font-semibold hover:bg-primary-dark transition-colors"
          >
            Return home <ArrowRight size={16} weight="bold" />
          </Link>
          <Link
            to="/contact"
            data-testid="unsub-contact-btn"
            className="inline-flex items-center gap-2 border border-primary text-primary rounded-full px-6 py-3 font-semibold hover:bg-primary/5 transition-colors"
          >
            <Envelope size={16} weight="duotone" />
            Contact the ministry
          </Link>
        </div>
      </div>
    </div>
  );
};

export default Unsubscribed;
